import { ApiSuccess, KnowledgeHubRecordType, PagePagination, PaginationParams } from '../../types';
import { apiSlice } from '../api.services';

type CreateKnowledgeHubPayload = {
  content: string;
  type: KnowledgeHubRecordType;
};

type UpdateKnowledgeHubPayload = {
  recordId: string;
  content: string;
};

type KnowledgeHubResponse = {
  record: KnowledgeHubRecord;
};

type GetKnowledgeHubPayload = PaginationParams & {
  type: KnowledgeHubRecordType;
  orgId?: string;
  search?: string;
};

export type KnowledgeHubRecord = {
  id: string;
  orgId: string;
  content: string;
  type: KnowledgeHubRecordType;
  createdAt: Date;
  updatedAt: Date;
};

type GetKnowledgeHubResponseData = {
  records: KnowledgeHubRecord[];
  pagination: PagePagination;
};

const enhancedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createKnowledgeHub: builder.mutation<ApiSuccess<KnowledgeHubResponse>, CreateKnowledgeHubPayload>({
      query: (body) => ({
        url: '/knowledge-hub/create',
        method: 'POST',
        body,
      }),
    }),
    deleteKnowledgeHub: builder.mutation<ApiSuccess<KnowledgeHubResponse>, string>({
      query: (recordId) => ({
        url: `/knowledge-hub/${recordId}`,
        method: 'DELETE',
      }),
    }),
    updateKnowledgeHub: builder.mutation<ApiSuccess<KnowledgeHubResponse>, UpdateKnowledgeHubPayload>({
      query: ({ recordId, ...body }) => ({
        url: `/knowledge-hub/${recordId}`,
        method: 'POST',
        body,
      }),
    }),
    getKnowledgeHub: builder.mutation<ApiSuccess<GetKnowledgeHubResponseData>, GetKnowledgeHubPayload>({
      query: ({ orgId, page, perPage, ...body }) => ({
        url: '/knowledge-hub',
        method: 'POST',
        params: { orgId, page, perPage },
        body,
      }),
    }),
  }),
});

export const {
  useCreateKnowledgeHubMutation,
  useDeleteKnowledgeHubMutation,
  useGetKnowledgeHubMutation,
  useUpdateKnowledgeHubMutation,
} = enhancedApiSlice;
